import * as en from './en'
import * as fr from './fr'

export default {
  en,
  fr,
}
